import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel } from 'react-bootstrap';
import { Column, Table } from 'react-virtualized';
import { Confirm } from 'react-confirm-bootstrap';
import Switcher from 'react-switcher';
import ReactTelInput from 'react-telephone-input';
import _ from 'lodash';

import CitiesComponent from './CitiesComponent';
import CountriesComponent from './CountriesComponent';
import UserTeams from './UserTeams.js';
import { gettext } from '../../../i18n/service.js';
import * as Validation from '../../../businessLogic/fieldValidation.js';
import LoopbackHttp from '../../../businessLogic/LoopbackHttp.js';
import { DriverCodImg } from '../../DriverCodImg';
import * as settingsActions from '../../../actions/settingsActions';
import * as appActions from '../../../actions/appActions';
import * as fleetActions from '../../../actions/fleetOwnerActions';
import DeleteModal from '../../modals/DeleteModal.js';

class DriversComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.selectedDriver = undefined;
    this.addToDefaultTeam = false;
    this.editDriver = false;
    this.createDriver = false;
    this.addedTeams = [];
    this.removedTeams = [];

    _.bindAll(this, ['flipEditDriver', 'resetState', 'createNewDriver', 'flipCreateDriver',
      'renderDriverCreateForm', 'getVehicle', 'resetBools', 'getSelectedDriver', 'renderDriverForm',
      'validateDriverFields', 'renderDriverEditForm', 'getTeams', 'renderActivateButtons', 'activateDeactivateDriver',
      'toggleAddToDefaultTeam', 'setCity', 'resetCashOnDelivery', 'clearCity', 'onConfirmReset', 'setCountry', 'deleteDriver']);
    this.state = {
      firstName: undefined,
      email: undefined,
      phone: undefined,
      vehicleType: undefined,
      driverCommissionPercent: undefined,
      password: undefined,
      confirmPassword: undefined,
      cityId: undefined,
      countryId: undefined,
      teamId: undefined,
      filterValue: undefined,
      id: undefined
    }
    this.baseState = this.state;
  }

  componentDidMount() {
    this.props.appActions.startSpinner();
    if (LoopbackHttp.isFleet) {
      this.props.settingsActions.getFleetDrivers(this.props.company.id);
      this.props.settingsActions.getTeamsForFleetSettings(this.props.company.id);
    } else if (LoopbackHttp.isOperator) {
      this.props.settingsActions.getOperatorDrivers(this.props.account.id);
      this.props.settingsActions.getTeamsForOperatorSettings(this.props.account.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.drivers !== this.props.drivers)
      this.props.appActions.endSpinner();

    if (nextProps.drivers !== this.props.drivers && this.selectedDriver) {
      this.props.fetchCityForInfo(this.selectedDriver.cityId);
      this.setState(this.selectedDriver);
    }
  }

  teamOperations = () => {
    if (this.addedTeams.length > 0) {
      this.addedTeams.map((team) => {
        this.props.fleetActions
          .addToTeam(team,
            'driver',
            this.state.id);
      })
    }
    if (this.removedTeams.length > 0) {
      this.removedTeams.map((team) => {
        this.props.fleetActions
          .removeFromTeam(team,
            'driver',
            this.state.id);
      })
    }
  }

  toggleAddToDefaultTeam(e) {
    this.addToDefaultTeam = !this.addToDefaultTeam;
    if (this.addToDefaultTeam)
      this.setState({ teamId: _.find(this.props.teams, { default: true }).id });
    else
      this.setState({ teamId: undefined });
  }

  clearCity() {
    this.setState({ cityId: undefined });
  }

  getTeams() {
    return _.map(this.props.teams, (team) => (
      <option key={`team_${team.id}`} value={team.id}>
        {team.name}
      </option>
    ));
  }

  getVehicle(type) {
    return _.find(this.props.vehicles, { size: type });
  }

  getSelectedDriver(id) {
    this.resetBools();
    this.props.appActions.startSpinner();
    this.props.settingsActions.getDriver(id);
    this.selectedDriver = _.find(this.props.drivers, { 'id': id });
    this.setState(this.selectedDriver);
  }

  flipCreateDriver() {
    // this.resetBools();
    this.createDriver = !this.createDriver;
    this.resetState();
  }

  flipEditDriver() {
    this.resetBools();
    this.editDriver = !this.editDriver;
    this.forceUpdate();
    if (this.editDriver && this.selectedDriver)
      this.props.settingsActions.fetchCitiesByCountryId(this.selectedDriver.countryId);
  }

  resetState() {
    this.selectedDriver = undefined;
    for (var prop in this.state) {
      delete this.state[prop];
    }
    this.setState(this.baseState);
  }

  resetBools() {
    this.createDriver = false;
    this.editDriver = false;
  }

  getTeamsAfterEdit = (addedTeams, removedTeams) => {
    this.addedTeams = addedTeams;
    this.removedTeams = removedTeams;
    this.setState({});
  }

  createNewDriver() {
    if (!this.validateDriverFields())
      return false;
    else if (!Validation.passValdationForCreating(this.state.password, this.props.showMessage))
      return false;
    else {
      delete this.state['confirmPassword'];
      delete this.state.filterValue;
      this.state.companyId = this.props.company.id;
      //this.props.startSpinner();
      var driverInfo = this.state;
      driverInfo.phone = driverInfo.phone.toString();
      this.props.settingsActions.createDriver(this.state.teamId, driverInfo);
      //this.props.endSpinner();
      this.resetBools();
      this.resetState();
    }
  }

  updateDriver() {
    if (!this.validateDriverFields())
      return false;
    else {
      delete this.state['confirmPassword'];
      delete this.state.filterValue;
      //this.props.startSpinner();
      this.props.settingsActions.updateDriver(this.state);
      this.teamOperations();
      let driverId = this.state.id;
      this.props.fetchCityForInfo(this.state.cityId);
      this.resetBools();
      this.resetState();
      this.getSelectedDriver(driverId);
    }
  }

  activateDeactivateDriver(params) {
    let fields = {
      id: this.state.id
    }
    if (params && 'blocked' in params) {
      fields.blocked = params.blocked;
    } else {
      fields.driverStatus = this.selectedDriver.driverStatus === 'active' ? 'inactive' : 'active'
    }
    this.props.appActions.startSpinner();
    this.props.settingsActions.updateDriver(fields);
  }

  deleteDriver() {
    this.props.startSpinner();
    this.props.settingsActions.deleteDriver(this.state.id);
    this.resetBools();
    this.resetState();
  }

  setCity(city) {
    this.setState({ cityId: city.id })
  }

  setCountry(country) {
    this.setState({ countryId: country.id });
    this.props.settingsActions.fetchCitiesByCountryId(country.id);
  }

  validateDriverFields() {
    return Validation.emailValdation(this.state.email, this.props.showMessage)
      && Validation.nameValidation(this.state.firstName, this.props.showMessage)
      && Validation.passValdation(this.state.password, this.state.confirmPassword, this.props.showMessage)
      && Validation.phoneValdation(this.state.phone, this.props.showMessage)
      && Validation.countryValdation(this.state.countryId, this.props.showMessage)
      && Validation.cityValdation(this.state.cityId, this.props.showMessage)
      && (this.editDriver || Validation.teamValdation(this.state.teamId, this.props.showMessage))
      && Validation.vehicleValdation(this.state.vehicleType, this.props.showMessage)
      && Validation.driverCommissionPercentValdation(this.state.driverCommissionPercent, this.props.showMessage);
  }

  resetCashOnDelivery(driver) {
    this.props.resetCashOnDelivery(driver.id);
    driver.cashOnDelivery = 0;
    this.setState(driver);
  }

  setDriverCommision(commission) {
    if (commission > 100) {
      commission = 100;
    }

    this.setState({ driverCommissionPercent: commission })
  }
  onConfirmReset() {
    this.resetCashOnDelivery(this.selectedDriver);
  }
  renderDriverForm() {
    return (
      <div className="dispatcher_profile">
        <Jumbotron className="position_relative">
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('DRIVER-INFO')}</h3>
          </div>
          <Row>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedDriver.email}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedDriver.firstName}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedDriver.phone}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.props.getCountryByCityId(this.selectedDriver.countryId)}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.props.getCityById(this.props.cityForInfo)}</h4></label>
                </Col>
              </Row>

              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('SWITCHER-STATUS')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  {this.renderActivateButtons()}
                </Col>
              </Row>

              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('BLOCKED-PERMITTED')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  {this.renderBlokedButtons()}
                </Col>
              </Row>

              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('RESET-COD')}</h4></ControlLabel>
                  <DriverCodImg driver={this.selectedDriver} company={this.props.company} styleImg={{ margin: '0px 0px 10px 10px' }} />
                </Col>
                <Col sm={4}>
                  <label><h4>{this.selectedDriver.cashOnDelivery} / {this.props.company.cashOnDeliveryCap}</h4></label>
                </Col>

                <Col sm={2}>
                  {!this.selectedDriver.cashOnDelivery || this.selectedDriver.cashOnDelivery === 0 ? null : <Confirm
                    onConfirm={this.onConfirmReset}
                    body="Are you sure to reset?"
                    confirmText="Confirm"
                    title="Confirmation" style={{ background: '#60285E', color: 'white', position: 'absolute', right: '-90%' }}><button className="btn btn-default">{gettext('RESET')}</button></Confirm>}
                </Col>
              </Row>

            </div>
            <div className="botom_line" />
            <div className="text_align_center margin_bottom_em">
              <h3>{gettext('VEHICLE-INFO')}</h3>
            </div>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('VEHICLE-TYPE')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label>
                    {this.selectedDriver.vehicleType &&
                      <img className="driver_info_vehicle" alt={this.getVehicle(this.selectedDriver.vehicleType).type} src={this.getVehicle(this.selectedDriver.vehicleType).icon} height="20" />
                    }
                  </label>
                </Col>
              </Row>
            </div>
            <div className="botom_line" />
            <div className="text_align_center margin_bottom_em">
              <h3>{gettext('PAYMENT-INFO')}</h3>
            </div>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('DRIVER-COMMISSION')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedDriver.driverCommissionPercent}{' %'}</h4></label>
                </Col>
              </Row>
            </div>
            <div className="botom_line" />
            <div className="text_align_center margin_bottom_em">
              <h3>{gettext('TEAMS')}</h3>
            </div>
            <div className="user_data center_div">
              <Row>
                <UserTeams userId={this.selectedDriver.id} userRole={'Driver'} />
              </Row>
            </div>
          </Row>
          <div className="edit_link">
            <a onClick={() => this.flipEditDriver()}><h4>{gettext('EDIT')}</h4></a>
          </div>
        </Jumbotron>
      </div>
    );
  }

  renderDriverEditForm() {
    return (
      <Jumbotron className="position_relative">
        <div className="text_align_center margin_bottom_em">
          <h2>{gettext('EDIT-DRIVER')}</h2>
        </div>
        <div className="text_align_center margin_bottom_em">
          <h4>{gettext('DRIVER-INFO')}</h4>
        </div>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  defaultValue={this.selectedDriver.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  placeholder={gettext('EMAIL')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder={gettext('PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CONFIRM-PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  placeholder={gettext('CONFIRM-PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  defaultValue={this.selectedDriver.firstName}
                  onChange={(e) => this.setState({ firstName: e.target.value })}
                  placeholder={gettext('NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  preferredCountries={['sa']}
                  initialValue={"" + this.selectedDriver.phone + ""}
                  flagsImagePath='./flags.png'
                  onChange={(telNumber, selectedCountry) => {
                    this.setState({ phone: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CountriesComponent
                  countries={this.props.countries}
                  onSelect={this.setCountry}
                  clearCity={this.clearCity}
                  defaultValue={this.props.getCountryById(this.selectedDriver.countryId)} />
                {/* <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  onChange={(e) => {
                    this.setState({ countryId: e.target.value });
                    this.props.settingsActions.fetchCitiesByCountryId(e.target.value);
                  }}
                  value={this.state.countryId}
                  name="country">
                  {this.props.getCountries(this.selectedDriver.countryId)}
                </FormControl> */}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CitiesComponent
                  cities={this.props.cities}
                  onSelect={this.setCity}
                  clearCity={this.clearCity}
                  defaultValue={this.props.getCityById(this.props.cityForInfo)} />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TYPE')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  onChange={(e) => this.setState({ isFullTime: e.target.value })}
                  name="driver-type">
                  <option value={true} selected={this.selectedDriver.isFullTime}>{gettext('FULL-TIME-DRIVER')}</option>
                  <option value={false} selected={!this.selectedDriver.isFullTime}>{gettext('FREELANCER-DRIVER')}</option>
                </FormControl>
              </Col>
            </Row>


          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('VEHICLE-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('VEHICLE-TYPE')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl componentClass="select" name="vehicleType" placeholder="select"
                  onChange={(e) => this.setState({ vehicleType: parseInt(e.target.value) })}>
                  {this.props.getVehicles(this.state.vehicleType)}
                </FormControl>
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('PAYMENT-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DRIVER-COMMISSION')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  required={true}
                  defaultValue={this.selectedDriver.driverCommissionPercent}
                  onChange={(e) => this.setState({ driverCommissionPercent: e.target.value })}
                  placeholder={gettext('DRIVER-COMMISSION')} />
              </Col>
            </Row>
          </div>
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('TEAMS')}</h3>
          </div>
          <div className="user_data center_div">
            <Row>
              <UserTeams
                isEdit
                getTeamsAfterEdit={this.getTeamsAfterEdit} />
            </Row>
          </div>
        </Row>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.updateDriver()}>{gettext('SAVE')}</Button>
          <Button bsStyle="danger" onClick={() => { this.resetState(); this.flipEditDriver(); }}>{gettext('CANCEL')}</Button>
        </div>
      </Jumbotron>
    );
  }

  renderDriverCreateForm() {

    return (
      <Jumbotron className="position_relative">
        <div className="text_align_center margin_bottom_em">
          <h2>{gettext('NEW-DRIVER')}</h2>
        </div>
        <div className="text_align_center margin_bottom_em">
          <h4>{gettext('DRIVER-INFO')}</h4>
        </div>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  placeholder={gettext('EMAIL')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder={gettext('PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CONFIRM-PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  placeholder={gettext('CONFIRM-PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ firstName: e.target.value })}
                  placeholder={gettext('NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  preferredCountries={['sa']}
                  flagsImagePath='./flags.png'
                  onChange={(telNumber, selectedCountry) => {
                    this.setState({ phone: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CountriesComponent
                  countries={this.props.countries}
                  onSelect={this.setCountry}
                  clearCity={this.clearCity} />
                {/* <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  onChange={(e) => {
                    this.setState({ countryId: e.target.value });
                    this.props.settingsActions.fetchCitiesByCountryId(e.target.value);
                  }}
                  name="country">
                  <option disabled selected value={undefined}>{gettext('SELECT-COUNTRY')}</option>
                  {this.props.getCountries()}
                </FormControl> */}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CitiesComponent
                  cities={this.props.cities}
                  clearCity={this.clearCity}
                  onSelect={this.setCity} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TEAM')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  componentClass="select"
                  className="_order_"
                  disabled={this.addToDefaultTeam}
                  placeholder="select"
                  onChange={(e) => this.setState({ teamId: e.target.value })}
                  name="city">
                  <option disabled selected value={undefined}>{gettext('SELECT-TEAM')}</option>
                  {this.getTeams()}
                </FormControl>
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                      checked={this.addToDefaultTeam}
                      onChange={(e) => this.toggleAddToDefaultTeam(e)} />
                    {gettext('ADD-TO-DEFAULT-TEAM')}
                    {this.addToDefaultTeam && _.find(this.props.teams, { default: true }).name ? ' - ' + _.find(this.props.teams, { default: true }).name : ''}
                  </label>
                </div>
              </Col>
            </Row>
          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('VEHICLE-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('VEHICLE-TYPE')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl componentClass="select" name="vehicleType" placeholder="select"
                  onChange={(e) => this.setState({ vehicleType: parseInt(e.target.value) })}>
                  <option disabled selected value={undefined}>{gettext('SELECT-VEHICLE')}</option>
                  {this.props.getVehicles()}
                </FormControl>
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('PAYMENT-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DRIVER.DRIVER-COMMISSION-PERCENT')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  max="100"
                  value={this.state.driverCommissionPercent + ""}
                  required={true}
                  onChange={(e) => this.setDriverCommision(parseInt(e.target.value))}
                  placeholder={gettext('DRIVER.DRIVER-COMMISSION-PERCENT')} />
              </Col>
            </Row>
          </div>
        </Row>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.createNewDriver()}>{gettext('SAVE')}</Button>
          <Button bsStyle="danger" onClick={() => { this.resetState(); this.flipCreateDriver(); }}>{gettext('CANCEL')}</Button>
        </div>
      </Jumbotron>
    );
  }

  renderActivateButtons() {
    return (
      <div className="switcher">
        <Switcher
          on={this.selectedDriver.driverStatus === 'active'}
          onClick={() => this.activateDeactivateDriver()}>
        </Switcher>
      </div>
    )
  }

  renderBlokedButtons() {
    return (
      <div className="switcher">
        <Switcher
          on={!this.selectedDriver.blocked}
          onClick={() => this.activateDeactivateDriver({ blocked: !this.selectedDriver.blocked })}>
        </Switcher>
      </div>
    )
  }
  deleteCallback = () => {
    this.resetBools();
    this.resetState();
  }
  render() {
    let drivers = _.uniqBy(this.props.drivers, 'id');

    drivers = _.filter(drivers, (driver) => {
      return this.state.filterValue
        ? driver.firstName.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
        || driver.email.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
        : true;
    });

    return (
      <div className="dispatcher_profile">
        <Jumbotron>
          <div className="item_head_title">
            <h3>{gettext('DRIVERS')}</h3>
          </div>
          <Row className="center_flex margin_bottom_em">
            <Col sm={10}>
              <Col sm={12}>
                <FormControl
                  type="text"
                  required={true}
                  placeholder={gettext('SEARCH')}
                  onChange={(e) => this.setState({ filterValue: e.target.value })} />
              </Col>
            </Col>
          </Row>
          <Row className="center_flex">
            <Col sm={10}>
              <Col sm={12}>

                <div className="table_container">
                  <Table
                    width={300}
                    height={300}
                    headerHeight={20}
                    rowHeight={30}
                    rowClassName={({ index }) =>
                      this.selectedDriver
                        && drivers[index] === this.selectedDriver ? 'active' : ''
                    }
                    rowCount={drivers.length}
                    rowGetter={({ index }) => drivers[index]}
                    onRowClick={(e) => {
                      this.getSelectedDriver(e.rowData.id);
                    }}
                  >
                    <Column
                      label='Name'
                      dataKey='firstName'
                      width={500}
                    />
                    <Column
                      width={500}
                      label='Email'
                      dataKey='email'
                    />
                    <Column
                      width={500}
                      label='Status'
                      dataKey='driverStatus'
                    />
                  </Table>
                </div>
                <div className="milti_controls">
                  {
                    !LoopbackHttp.isOperator || (LoopbackHttp.isOperator && this.props.account.canAddDriver)
                      ? <Button className="multi_btn margin_bottom_halfem" onClick={() => { this.flipCreateDriver() }}>+</Button> : ''
                  }
                  {
                    this.selectedDriver &&
                    <DeleteModal
                      delete={this.deleteDriver}
                      id={this.state.id}
                      callBack={this.deleteCallback}
                      text={`${gettext('DELETE-USER-CONFIRMATION')} ${this.selectedDriver.firstName}`}
                      buttonClass={'multi_btn margin_bottom_halfem'}
                      buttonText={'-'} />
                  }
                </div>
              </Col>

            </Col>
          </Row>
        </Jumbotron>
        {
          this.createDriver ? this.renderDriverCreateForm() : ''
        }
        {
          this.selectedDriver
            ? this.editDriver ? this.renderDriverEditForm() : this.renderDriverForm()
            : ''
        }

      </div>
    );
  }
}

DriversComponent.propTypes = {
  showMessage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    drivers: state.settingsPageReducer.drivers,
    company: state.appReducer.company,
    account: state.appReducer.account,
    teams: state.settingsPageReducer.teams,
    userTeams: state.settingsPageReducer.userTeams,
    cities: state.settingsPageReducer.cities
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    appActions: bindActionCreators(appActions, dispatch),
    fleetActions: bindActionCreators(fleetActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriversComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/DriversComponent.js